var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c(
        "v-flex",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false - _vm.value,
              expression: "false - value",
            },
          ],
        },
        [
          _c("input", {
            ref: "myFiles",
            attrs: { type: "file", id: "file", multiple: "" },
            on: { input: _vm.setFiles },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-btn",
            _vm._b(
              {
                attrs: { outline: "", depressed: "" },
                on: {
                  click: function ($event) {
                    return _vm.$refs.myFiles.click()
                  },
                },
              },
              "v-btn",
              _vm.$attrs,
              false
            ),
            [_vm._v("\n      Add Attachments\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.files, function (file, index) {
        return _c(
          "v-flex",
          { key: file.name, attrs: { "pa-0": "", "pt-2": "", xs12: "" } },
          [
            _vm._v("\n    " + _vm._s(file.name) + "\n    "),
            _c(
              "v-btn",
              _vm._b(
                {
                  attrs: {
                    outline: "",
                    depressed: "",
                    small: "",
                    color: "error",
                  },
                  on: {
                    click: function ($event) {
                      ;[
                        _vm.files.splice(index, 1),
                        _vm.$emit("input", _vm.files),
                      ]
                    },
                  },
                },
                "v-btn",
                _vm.$attrs,
                false
              ),
              [_vm._v("\n      Remove\n    ")]
            ),
            _vm._v(" "),
            _c("ControlTextArea", {
              attrs: { label: `Comments (${file.name})` },
              on: {
                input: function ($event) {
                  return _vm.$emit("input", _vm.files)
                },
              },
              model: {
                value: file.comments,
                callback: function ($$v) {
                  _vm.$set(file, "comments", $$v)
                },
                expression: "file.comments",
              },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }